import { MODULES } from '@core/constants/modules.contants';
import { ROUTER } from '@core/constants/router.constants';
import { useService } from '@policoders/di';
import Layout from '@shared/components/layout.component';
import { NavbarItem } from '@shared/components/navbar/navbar-item.model';
import NavbarService from '@shared/components/navbar/navbar.service';
import { Outlet } from 'react-router-dom';

export const HealthLayout: React.FC = () => {
  const items: NavbarItem[] = [{ label: 'Pacientes', to: ROUTER.HEALTH.PATIENTS.INDEX, type: 'nav-item' }];
  const navbar = useService<NavbarService>('NavbarService');
  navbar.set({ module: MODULES.HEALTH, navbar: items });
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};
